module.exports = __webpack_public_path__ + "img/why-img.63329ff7.png";